import * as swiklyService from '../services/swikly'
import {
  CreateRequestPayload,
  CreateRequestResponse,
  GetRequestResponse,
} from '../services/swikly'

/**
 * Action types for Swikly operations
 */
export const ACTIONS = {
  CREATE_SWIKLY_CAUTION_REQUEST: 'CREATE_SWIKLY_CAUTION_REQUEST',
  CREATE_SWIKLY_CAUTION_SUCCESS: 'CREATE_SWIKLY_CAUTION_SUCCESS',
  CREATE_SWIKLY_CAUTION_FAILURE: 'CREATE_SWIKLY_CAUTION_FAILURE',
  GET_SWIKLY_CAUTION_STATUS_REQUEST: 'GET_SWIKLY_CAUTION_STATUS_REQUEST',
  GET_SWIKLY_CAUTION_STATUS_SUCCESS: 'GET_SWIKLY_CAUTION_STATUS_SUCCESS',
  GET_SWIKLY_CAUTION_STATUS_FAILURE: 'GET_SWIKLY_CAUTION_STATUS_FAILURE',
}

// Create caution actions
/**
 * Action dispatched when creating a Swikly caution request starts
 */
export const CREATE_SWIKLY_CAUTION_REQUEST = () => ({
  type: ACTIONS.CREATE_SWIKLY_CAUTION_REQUEST,
})

/**
 * Action dispatched when creating a Swikly caution succeeds
 * @param response - The response from the Swikly API
 */
export const CREATE_SWIKLY_CAUTION_SUCCESS = (
  response: CreateRequestResponse
) => ({
  type: ACTIONS.CREATE_SWIKLY_CAUTION_SUCCESS,
  payload: response,
})

/**
 * Action dispatched when creating a Swikly caution fails
 * @param error - The error that occurred
 */
export const CREATE_SWIKLY_CAUTION_FAILURE = (error: any) => ({
  type: ACTIONS.CREATE_SWIKLY_CAUTION_FAILURE,
  error,
})

// Get caution status actions
/**
 * Action dispatched when getting Swikly caution status starts
 */
export const GET_SWIKLY_CAUTION_STATUS_REQUEST = () => ({
  type: ACTIONS.GET_SWIKLY_CAUTION_STATUS_REQUEST,
})

/**
 * Action dispatched when getting Swikly caution status succeeds
 * @param response - The response from the Swikly API
 */
export const GET_SWIKLY_CAUTION_STATUS_SUCCESS = (
  response: GetRequestResponse
) => ({
  type: ACTIONS.GET_SWIKLY_CAUTION_STATUS_SUCCESS,
  payload: response,
})

/**
 * Action dispatched when getting Swikly caution status fails
 * @param error - The error that occurred
 */
export const GET_SWIKLY_CAUTION_STATUS_FAILURE = (error: any) => ({
  type: ACTIONS.GET_SWIKLY_CAUTION_STATUS_FAILURE,
  error,
})

// Thunk actions
/**
 * Thunk action to create a new Swikly caution
 * @param data - The caution creation payload
 * @returns Promise that resolves with the created request
 */
export const createSwiklyCaution = (data: CreateRequestPayload) => {
  return async (dispatch: any) => {
    dispatch(CREATE_SWIKLY_CAUTION_REQUEST())
    try {
      const response = await swiklyService.createSwiklyCaution(data)
      dispatch(CREATE_SWIKLY_CAUTION_SUCCESS(response))
      return response
    } catch (error) {
      dispatch(CREATE_SWIKLY_CAUTION_FAILURE(error))
      throw error
    }
  }
}

/**
 * Thunk action to get the status of a Swikly caution
 * @param swiklyId - The Swikly request ID
 * @returns Promise that resolves with the request details
 */
export const getSwiklyCautionStatus = (swiklyId: string) => {
  return async (dispatch: any) => {
    dispatch(GET_SWIKLY_CAUTION_STATUS_REQUEST())
    try {
      const status = await swiklyService.getSwiklyCautionStatus(swiklyId)
      dispatch(GET_SWIKLY_CAUTION_STATUS_SUCCESS(status))
      return status
    } catch (error) {
      dispatch(GET_SWIKLY_CAUTION_STATUS_FAILURE(error))
      throw error
    }
  }
}
